module.exports = __webpack_public_path__ + "number3.png?48c2aa6c5854f57119fa6413353440dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/number3.png
// module id = 4
// module chunks = 0